export default {
  init() {
    const fileInput = document.querySelector('.js-form-file-input');
    if(fileInput) {
      fileInput.addEventListener('change', (e) => {
        const target = e.target;
        const parent = target.closest('.js-form-file');

        if(parent) {
          const nameTarget = parent.querySelector('.js-form-file-name');

          if(nameTarget) {
            if (target.files[0] && nameTarget) {
              nameTarget.textContent = target.files[0].name;
              fileInput.parentElement.classList.add('focused');
            } else {
              nameTarget.textContent = '';
            }
          }
        }
      }, false);

      const contact = document.querySelector('.js-contact');
      if(contact) {
        document.addEventListener('wpcf7mailsent', () => {
          const contactFromBox = contact.querySelector('.js-contact-form');
          const contactThxBox = contact.querySelector('.js-contact-thx');

          contactFromBox.classList.add('hidden');
          contactThxBox.classList.remove('hidden');

          window.location.hash = 'contact'
        }, false);
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/modules/form.js